import { SUBDOMAIN_NAME_STORAGE_KEY } from "../constants/subdomainName";
import { tokenService } from "../services/tokenService";
import { clearAuth0SpaCache } from "./auth0Cache";

/** Clears API tokens and app localStorage; does not clear Auth0 SPA cache (needed for SDK logout). */
export const clearAppTokensFromStorage = () => {
  tokenService.clearToken();
  localStorage.removeItem("user_uuid");
  localStorage.removeItem("workspace_uuid");
  localStorage.removeItem("favoriteAccount");
  localStorage.removeItem("userId");
  localStorage.removeItem(SUBDOMAIN_NAME_STORAGE_KEY);
  localStorage.removeItem("workspace_slug");
  localStorage.removeItem("tenant_slug");
};

const federatedLogoutRedirect = () => {
  const domain = process.env.REACT_APP_AUTH0_DOMAIN;
  const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID;
  const returnTo = encodeURIComponent(window.location.origin);
  if (domain && clientId) {
    window.location.assign(
      `https://${domain}/v2/logout?client_id=${clientId}&returnTo=${returnTo}`,
    );
    return true;
  }
  return false;
};

/**
 * Auth0 logout without wiping SPA cache first (SDK needs it to build the logout request).
 * @param {Function} logout - useAuth0().logout
 * @param {{ localOnly?: boolean }} options
 */
export const safeAuth0Logout = async (logout, { localOnly = false } = {}) => {
  try {
    if (localOnly) {
      await logout({ localOnly: true });
    } else {
      await logout({ logoutParams: { returnTo: window.location.origin } });
    }
  } catch (err) {
    console.warn("[Auth0] SDK logout failed:", err);
    clearAuth0SpaCache();
    if (!localOnly && !federatedLogoutRedirect()) {
      throw err;
    }
  } finally {
    if (localOnly) {
      clearAuth0SpaCache();
    }
  }
};

/** Fire-and-forget sign out safe for onClick handlers (no unhandled promise rejections). */
export const runSignOut = (logout, { authStore, workspaceStore } = {}) => {
  void (async () => {
    clearAppTokensFromStorage();
    try {
      await safeAuth0Logout(logout, { localOnly: false });
      // Federated logout redirects away; do not clear MobX here or App
      // re-renders with isAuthenticated true and userData null.
    } catch (err) {
      console.error("[Auth0] Sign out failed:", err);
      authStore?.clear();
      workspaceStore?.clear();
      clearAuth0SpaCache();
    }
  })();
};
